/**
*	Various workaround patches for jQuery 2.1.4 and jQueryUI 1.9.2
*	Several of the jQuery UI plugins that Leica uses now chage a license fee to distribute the latest versions.
*	We are not upgrading FancyBox. The patches in this file allow the old plugins to work with
*	the new jQuery/jQueryUI.
*	
* FancyBox and several other jQuery plugins use the deprecatad $.browser object to detect browsers.
*/
$.browser = $.browser || {"safari": false, "opera": false, "webkit": false};

/*************************************************************************	
 * FancyBox uses the deprecated $.support to test for opacity support.
 */
$.support = $.support || {};

$(document).ready(function()
{
	// set up $.browser
	var ua = navigator.userAgent.toLowerCase();
	if (undefined === $.browser.chrome)
	{
		setBrowser('chrome', ua, /(chrome)[ \/]([\w.]+)/, /chrome\/[0-9]*/g);
	}
	if (undefined === $.browser.mozilla)
	{
		setBrowser('mozilla', ua, /(firefox)[ \/]([\w.]+)/, /firefox\/[0-9]*/g);
	}
	if (undefined === $.browser.msie)
	{
		setBrowser('msie', ua, /(trident)[ \/]([\w.]+)/, /trident\/[0-9]*/g);
		if ($.browser.msie)
		{
			// determine IE version based on Trident version
			switch($.browser.version)
			{
				case '7':
					$.browser.version = 11;
					break;
				case '6':
					$.browser.version = 10;
					break;
				case '5':
					$.browser.version = 9;
					break;
			}
		}
	}

	/*
	 * set up $.browser for current browser
	 * 
	 * browserName	- the $.browser property name for the browser, e.g. 'msie'
	 * userAgent	- the browser user agent string
	 * uaRegx		- regular expression to eval userAgent
	 * versRegx		- regular expression to extract browser version from userAgent
	 */
	function setBrowser(browserName, userAgent, uaRegex, versRegex)
	{
		$.browser[browserName] = uaRegex.exec(userAgent) !== null;
		if ($.browser[browserName] == true && versRegex)
		{
			var vers = userAgent.match(versRegex);
			if (vers)
			{
				vers = vers.toString().split('/');
				if (vers.length > 1)
				{
					$.browser.version = vers[1];
				}
			}
		}
	}
	// set opacity support based on opacity's presence in the the body's CSS.
	$.support.opacity = $.support.opacity || undefined !== document.body.style.opacity;
});
